import React, { useMemo } from "react";

/**
 * Visual atmosphere: random spark particles + floating pIqaD-style runes.
 * Pure CSS animations, no JS loop.
 */
const RUNE_CHARS = [
  "⏃", "⏚", "⌬", "⎔", "⏁", "⏚", "⌖", "⌬", "⎈", "☸",
  "ᚷ", "ᛟ", "ᛉ", "ᛇ", "ᛞ", "ᚦ", "ᛏ", "ᛗ",
  "✦", "✧", "❖", "⟁", "△", "▼",
];

export const Sparks = ({ count = 18 }) => {
  const sparks = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 8,
        duration: 6 + Math.random() * 10,
        size: 1 + Math.random() * 3,
        hue: Math.random() > 0.5 ? "#E6B836" : "#FF6A6A",
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {sparks.map((s) => (
        <span
          key={s.id}
          className="spark"
          style={{
            left: `${s.left}%`,
            bottom: "-10px",
            width: `${s.size}px`,
            height: `${s.size}px`,
            background: s.hue,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export const FloatingRunes = ({ count = 16 }) => {
  const runes = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        char: RUNE_CHARS[Math.floor(Math.random() * RUNE_CHARS.length)],
        left: Math.random() * 100,
        delay: Math.random() * 12,
        duration: 18 + Math.random() * 22,
        size: 18 + Math.random() * 42,
        opacity: 0.08 + Math.random() * 0.25,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {runes.map((r) => (
        <span
          key={r.id}
          className="rune"
          style={{
            left: `${r.left}%`,
            bottom: "-80px",
            fontSize: `${r.size}px`,
            opacity: r.opacity,
            animationDuration: `${r.duration}s`,
            animationDelay: `${r.delay}s`,
          }}
        >
          {r.char}
        </span>
      ))}
    </div>
  );
};
